import { CustomError } from "ts-custom-error";
export class MastoUnexpectedError extends CustomError {
}
